<div class="category-wrapper">
  <div class="catoegories-title">
    CATEGORIES
  </div>
  <div class="categories-list">
    <app-custom-filter (askLogin)="askLogin.emit('filter')" [attribute]="'category'" [filterData]="filterData" [origin]="'sideMenu'"></app-custom-filter>
  </div>
  <div class="start-fundraiser">
    <a href="new/crowdfunding" target="_blank" class="start-sf-link"><button class="start-fundraiser-button" mat-button>Start a Fundraiser</button></a>
  </div>
</div>